import map from './map.js';
import property from './property.js';

// Convenience version of a common use case of `_.map`: fetching a property.
export default function pluck(obj, key) {
  return map(obj, property(key));
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/pluck.js
// module id = 282
// module chunks = 9